import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Questions: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.7577 22.8483C17.4856 22.8483 17.2191 22.7406 17.0185 22.5376L14.1856 19.6666H9.41641C9.12697 19.6666 8.89258 19.4292 8.89258 19.1366C8.89258 18.8441 9.12697 18.6066 9.41641 18.6066H14.403C14.5421 18.6066 14.6757 18.6626 14.774 18.7621L17.76 21.7883L17.7611 19.1366C17.7611 18.8441 17.9955 18.6066 18.2849 18.6066H20.3802C21.2469 18.6066 21.9517 17.8935 21.9517 17.0167V7.47707C21.9517 6.9109 21.6508 6.38458 21.167 6.10305C20.9158 5.95719 20.8295 5.63298 20.9736 5.37915C21.1183 5.12503 21.4371 5.03826 21.6888 5.18383C22.4971 5.65418 22.9994 6.53298 22.9994 7.47707V17.0169C22.9994 18.478 21.8243 19.6669 20.3802 19.6669H18.8087V21.7869C18.8087 22.2174 18.5545 22.6021 18.1606 22.7669C18.0301 22.8217 17.8927 22.8483 17.7577 22.8483Z'
        fill='url(#paint0_linear_12280_29103)'
        stroke='url(#paint1_linear_12280_29103)'
        strokeWidth='0.8'
      />
      <path
        d='M6.23914 19.6676C6.1042 19.6676 5.96758 19.6411 5.83711 19.5865C5.44431 19.422 5.19064 19.0373 5.19064 18.6074V16.4885H3.61915C2.17505 16.4885 1 15.2996 1 13.8385V4.2984C1 2.83732 2.17505 1.64844 3.61915 1.64844H17.2387C18.6828 1.64844 19.8579 2.83732 19.8579 4.2984V13.8383C19.8579 15.2994 18.6828 16.4882 17.2387 16.4882H9.81403L6.97892 19.3567C6.77777 19.5599 6.51125 19.6676 6.23914 19.6676ZM3.61887 2.70842C2.75225 2.70842 2.04738 3.42158 2.04738 4.2984V13.8383C2.04738 14.7151 2.75225 15.4282 3.61887 15.4282H5.71419C6.00362 15.4282 6.23802 15.6657 6.23802 15.9582V18.6071L9.2265 15.5834C9.32484 15.4839 9.45783 15.4282 9.59696 15.4282H17.2384C18.1051 15.4282 18.8099 14.7151 18.8099 13.8383V4.2984C18.8099 3.42158 18.1051 2.70842 17.2384 2.70842H3.61887Z'
        fill='url(#paint2_linear_12280_29103)'
        stroke='url(#paint3_linear_12280_29103)'
        strokeWidth='0.8'
      />
      <path
        d='M10.426 11.1855C10.1366 11.1855 9.90222 10.9481 9.90222 10.6555V10.2474C9.90222 9.47711 10.3344 8.77639 11.0588 8.37331C11.5751 8.08415 11.8333 7.48886 11.7014 6.89216C11.5944 6.41983 11.2077 6.02834 10.7392 5.92008C10.3679 5.83359 9.99497 5.90369 9.69017 6.1154C9.38733 6.32599 9.18422 6.65614 9.13254 7.02077C9.09119 7.31022 8.83221 7.51289 8.53914 7.46992C8.25306 7.42837 8.05415 7.15956 8.09521 6.87011C8.18881 6.21292 8.55367 5.61933 9.09678 5.24198C9.64575 4.86066 10.3132 4.73573 10.9722 4.88639C11.8383 5.0868 12.5258 5.78215 12.7234 6.65812C12.9591 7.72008 12.4937 8.78148 11.5656 9.3013C11.1798 9.51612 10.9502 9.86945 10.9502 10.2474V10.6555C10.9502 10.9481 10.7155 11.1855 10.426 11.1855Z'
        fill='url(#paint4_linear_12280_29103)'
        stroke='url(#paint5_linear_12280_29103)'
        strokeWidth='0.8'
      />
      <path
        d='M10.4281 13.31C10.7174 13.31 10.952 13.0727 10.952 12.78C10.952 12.4873 10.7174 12.25 10.4281 12.25C10.1388 12.25 9.9043 12.4873 9.9043 12.78C9.9043 13.0727 10.1388 13.31 10.4281 13.31Z'
        fill='url(#paint6_linear_12280_29103)'
        stroke='url(#paint7_linear_12280_29103)'
        strokeWidth='0.8'
      />
      <defs>
        <linearGradient
          id='paint0_linear_12280_29103'
          x1='11.8138'
          y1='6.32261'
          x2='20.9206'
          y2='20.8412'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_29103'
          x1='11.8138'
          y1='6.32261'
          x2='20.9206'
          y2='20.8412'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_29103'
          x1='4.90503'
          y1='2.87714'
          x2='12.8897'
          y2='19.6256'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_29103'
          x1='4.90503'
          y1='2.87714'
          x2='12.8897'
          y2='19.6256'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_29103'
          x1='9.0619'
          y1='5.25799'
          x2='12.429'
          y2='10.2379'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_29103'
          x1='9.0619'
          y1='5.25799'
          x2='12.429'
          y2='10.2379'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_29103'
          x1='10.1212'
          y1='12.3223'
          x2='10.6077'
          y2='13.2859'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_29103'
          x1='10.1212'
          y1='12.3223'
          x2='10.6077'
          y2='13.2859'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Questions;
